import axios from "axios";
import "bootstrap/dist/css/bootstrap.min.css";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import Slider from "react-slick";
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";
import { API_BASE_URL } from "../../../config/config";
import "./style.css";
import SliderSceleton from "./SliderSceleton";

const getSliderSettings = (windowWidth) => ({
  dots: true,
  infinite: true,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
  centerMode: true,
  centerPadding: windowWidth < 1000 ? "20px" : "60px",
  initialSlide: 0,
  autoplay: true,
  autoplaySpeed: 2500,
  pauseOnHover: true,
  pauseOnFocus: true,
  pauseOnDotsHover: true,
  focusOnSelect: true,
  afterChange: () => {
    window.dispatchEvent(new Event("resize"));
  },
  responsive: [
    {
      breakpoint: 1024,
      settings: { slidesToShow: 1, centerMode: true, centerPadding: "40px" },
    },
    {
      breakpoint: 800,
      settings: { slidesToShow: 1, centerMode: true, centerPadding: "30px" },
    },
    {
      breakpoint: 600,
      settings: { slidesToShow: 1, centerMode: true, centerPadding: "20px" },
    },
    {
      breakpoint: 480,
      settings: { slidesToShow: 1, centerMode: true, centerPadding: "15px" },
    },
  ],
});

const getNewsLink = (item) => {
  const typePath =
    item.type === 1
      ? "news"
      : item.type === 2
        ? "project"
        : item.type === 3
          ? "compi"
          : item.type === 4
            ? "tenders"
            : "job";
  return `/${typePath}/show/${item.id}`;
};

const SliderHome = () => {
  const [newsItems, setNewsItems] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [sliderSettings, setSliderSettings] = useState(
    getSliderSettings(window.innerWidth)
  );

  const { t, i18n } = useTranslation();
  const getInitialLanguageValue = () =>
    parseInt(localStorage.getItem("selectedLanguageValue")) || 2;

  useEffect(() => {
    const handleResize = () =>
      setSliderSettings(getSliderSettings(window.innerWidth));
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const getInitialLangCode = () => localStorage.getItem("currentLang") || "ru";

  useEffect(() => {
    i18n.changeLanguage(getInitialLangCode());
  }, [i18n]);

  useEffect(() => {
    const langCode = getInitialLanguageValue(i18n.language);
    setIsLoading(true);

    axios
      .get(`${API_BASE_URL}/api/events?lang=${langCode}&eventType=1&page=1`, {
        headers: {
          accept: "text/plain",
          "api-version": "1.0",
        },
      })
      .then((response) => {
        const items = response.data.enttities || response.data.entities || [];
        const firstFour = items.slice(0, 4);
        setNewsItems(firstFour);
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      })
      .finally(() => setIsLoading(false));
  }, [i18n.language]);

  return (
    <div className="container mt-10 headBloc">
      <div className="row theFle">
        <div data-aos="fade-up" className="col-12 col-md-6 fonTextHead mb-4">
          <span className="headTitle">{t("MainTitle")}</span>
          <br />
          <span className="headDescription">{t("MainDescription")}</span>
        </div>

        <div
          data-aos="flip-left"
          className="col-12 col-md-6 d-flex justify-content-center"
        >
          <div className="regions-sectionHead slider-container w-100">
            <Slider
              {...sliderSettings}
              dots={!isLoading && newsItems.length > 0}
              arrows={!isLoading && newsItems.length > 0}
            >
              {isLoading || newsItems.length === 0
                ? Array(3)
                    .fill(0)
                    .map((_, index) => (
                      <div key={index} className="HeadSlide">
                        <SliderSceleton />
                      </div>
                    ))
                : newsItems.map((item, index) => (
                    <div className="HeadSlide" key={index}>
                      <Link
                        to={getNewsLink(item)}
                        className="card test news-card-link"
                      >
                        <div className="position-relative">
                          <img
                            src={item.image}
                            className="card-img-tophd"
                            alt={
                              item.title?.replace(/<[^>]+>/g, "") || "News"
                            }
                          />
                          <div className="date-label position-absolute">
                            {new Date(item.createdDate).toLocaleDateString()}
                          </div>
                        </div>
                        <div className="card-body">
                          <h5 className="fw-bold news-card-title">
                            <span
                              dangerouslySetInnerHTML={{ __html: item.title }}
                            />
                          </h5>
                        </div>
                      </Link>
                    </div>
                  ))}
            </Slider>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SliderHome;